import { PlotImportWizard } from '@/components/plots/plot-import-wizard'

export function OperationsPlotsImport() {
  return <PlotImportWizard plotsBasePath="/operations/plots" />
}
